import {useCallback, useMemo, FC} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import url from 'url';
import Select from './formik/inputs/Select';
import {OptionsProp} from '../../constants/types';

type ListSelectFilterProps = {
  name: string,
  customValue?: string,
  label: string,
  disabled?: boolean,
  onChange?: (value: string) => void,
  options: Nullable<OptionsProp[]>,
  query: Dictionary<string>
}

const ListSelectFilter: FC<ListSelectFilterProps> = ({
  name, options, query, label, disabled, onChange, customValue
}: ListSelectFilterProps) => {
  const history = useHistory();
  const {pathname} = useLocation();

  const handleChange = useCallback(({target: {value}}) => {
    if (onChange) {
      return onChange(value);
    }

    history.push(
        url.format({
          pathname,
          query:
          {...query, [name]: value}
        }));
  }, [pathname, query, onChange]);

  const value = useMemo(() => {
    return customValue || options?.find(({value}) => value === query[name])?.value || '';
  }, [customValue, options, query[name]]);

  if (!options?.length) {
    return null;
  }

  return (
    <Select
      name={name}
      options={options}
      value={value}
      onChange={handleChange}
      size="small"
      label={label}
      disabled={disabled}
      autoWidth
    />
  );
};

export default ListSelectFilter;
